// removed by extract-text-webpack-plugin
module.exports = {"curator-info":"curator-info___HUcKu","label":"label___3v92j","curator":"curator___Qv2HW","image":"image___3wBWN","details":"details___2H4_K","name":"name___1PKMs","title":"title___HruQg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CuratorInfo/CuratorInfo.scss
// module id = 018r
// module chunks = 57